export const CheckMetaMaskConnectError = (code) => {
    switch (code){
        // case 4001:
        //     return "REJECTED_MSG";
        case -32002:
            return "METANOTI_POPUP";
        default :
            return "GENERAL_POPUP";
    }
}